import React from 'react';
import { Link } from 'react-router-dom';
import { BiInfoCircle } from 'react-icons/bi';
import { Colors } from '_styles';

// Old booking emails linked to /confirm-booking/:id/:airport, which confirmed a
// booking with no login. That flow has been removed; the route now lands here so
// links still sitting in inboxes don't hit a blank page.
const ConfirmBookingRetired = () => {
    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16,
            }}
        >
            <div style={{ maxWidth: 520, textAlign: 'center' }}>
                <BiInfoCircle size={72} color={Colors.PRM_LIGHT_BLUE} />
                <h1 className="mt-3" style={{ fontWeight: 'bold', fontSize: 24 }}>
                    This link is no longer used
                </h1>
                <p style={{ opacity: 0.7 }}>
                    Please log in to the PRM Assist portal or contact PRM Assist.
                </p>
                <Link to="/login" className="btn btn-primary mt-2">
                    Log in to the portal
                </Link>
            </div>
        </div>
    );
};

export default ConfirmBookingRetired;
